import { ApolloLink } from 'apollo-link';

import { bugsnagBreadcrumbLink, registerBugsnagUserLink } from 'setup/BugSnag';

import csrfLink from './csrfLink';
import errorLink from './errorLink';
import httpLink from './httpLink';
import operationObserverLink from './operationObserverLink';

/**
 * Build the composed final `ApolloLink` for our client.
 * Note: `.from` is basically a compose function for links.
 * @return {ApolloLink}
 */
export default function buildApolloLink() {
  return ApolloLink.from([
    bugsnagBreadcrumbLink,
    registerBugsnagUserLink,
    errorLink,
    csrfLink,
    operationObserverLink,
    httpLink,
  ]);
}



// WEBPACK FOOTER //
// ./src/setup/ApolloConnector/links/index.js